export default function NavFooter() {
    return (
        <div className="border-t border-gray-100">
            <div className="px-4 py-3 space-y-1">
                <a
                    href="/spif-terms"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center px-2 py-1 text-xxs text-gray-500 hover:text-blue-700 transition-colors"
                >
                    <span>SPIF Terms of Service</span>
                </a>
                <a
                    href="https://lionsfloor.com/terms-and-conditions/"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center px-2 py-1 text-xxs text-gray-500 hover:text-blue-700 transition-colors"
                >
                    <span>Terms of Service</span>
                </a>
                <a
                    href="https://lionsfloor.com/privacy-policy/"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center px-2 py-1 text-xxs text-gray-500 hover:text-blue-700 transition-colors"
                >
                    <span>Privacy Policy</span>
                </a>
            </div>
        </div>
    );
} 
